import { createGlobalStyle } from 'styled-components';
import appTheme from '@/styles/theme';

// Create the global style component
const GlobalDatePickerStyle = createGlobalStyle<{
  highlightedDays?: {
    dates: string[];
    legend?: string;
  };
}>`
  ${({ highlightedDays }) =>
    highlightedDays?.dates
      .map(
        (day) => `
        td.ant-picker-cell[title="${day}"] {
          background: ${appTheme.token.colorLightSecondary};
        }
      `,
      )
      .join('\n')}
`;

export default GlobalDatePickerStyle;
